import './nodeMessageReceiver.scss';
import template from './NodeMessageReceiverView.html';
import Type from 'data/type';

export const { Save } = Type({
    Save: [],
});
export const Delete = 'Delete';

export default {
    require: {
        ngModel: 'ngModel',
    },
    template,
    controller: class {
        constructor($scope, $timeout) {
            'ngInject';

            this.$scope = $scope;
            this.$timeout = $timeout;

            this.$scope.$watch('$ctrl.ngModel.$viewValue', () =>
                this._loadModel(),
            );
            this.$scope.$watch('$ctrl.expanded', () => {
                if (this.expanded) this._expand();
            });

            this.$scope.$on(Save, () => this.save());

            this.collapseResponse = true;
        }

        $onInit() {
            if (!this.ngModel)
                throw new Error(
                    'No ng-model directive supplied to node-message-receiver component',
                );
        }

        expandResponse() {
            this.collapseResponse = false;
        }

        save() {
            if (this.responseError) return;

            const responseContentKey = this._responseIsJson
                ? 'jsonContent'
                : 'plainContent';

            this._updateModel({
                content: this.content,
                state: this.state || undefined,
                priority: this.priority | 0,
                response: !this._model.response
                    ? undefined
                    : {
                        [responseContentKey]: this._responseIsJson
                            ? JSON.parse(this.responseContent)
                            : this.responseContent,
                        mediaType: this.responseType || 'text/plain',
                    },
                outState: this.outState || undefined,
            });
            this.$scope.$broadcast('Collapse');
        }

        cancel() {
            this._loadModel();
            this.$scope.$broadcast('Collapse');
        }

        delete() {
            this.$scope.$emit(Delete, { id: this._model.id });
        }

        setTouched() {
            this.ngModel.$setTouched();
        }

        get cardTitle() {
            return (
                (this.state || '*') +
                (this.outState ? ` \u2192 ${this.outState}` : '')
            );
        }

        // responseContent
        set responseContent(content) {
            this.responseError = false;
            this._responseContent = content;

            if (!this._responseIsJson) return;

            try {
                JSON.parse(content);
            } catch (e) {
                this.responseError = true;
            }
        }
        get responseContent() {
            return this._responseContent;
        }

        get _responseIsJson() {
            return !!this.responseType.match(/json$/i);
        }

        // priority
        set priority(priority) {
            this._priority = priority | 0;
        }
        get priority() {
            return this._priority;
        }

        get states() {
            return [...(this._states || []), this.state]
                .nub()
                .filter((s) => typeof s === 'string');
        }

        get _model() {
            return this.ngModel.$viewValue || {};
        }

        //
        _expand() {
            this.$scope.$broadcast('Expand');
        }

        _loadModel() {
            this.content = this._model.content;
            this.state = this._model.state;
            this._priority = this._model.priority || 0;
            this.outState = this._model.outState;
            this.type = this._model.type;
            this.settings = this._model.settings;
            const response = this._model.response || {};
            this.responseType = response.mediaType || 'text/plain';
            this._responseContent = this._responseIsJson
                ? JSON.stringify(response.jsonContent, null, 4)
                : response.plainContent;

            this.ngModel.$setPristine();
            this.ngModel.$setUntouched();
        }

        _updateModel(value) {
            this.ngModel.$setViewValue({
                ...this._model,
                ...value,
            });
            this.ngModel.$setPristine();
            this.ngModel.$setUntouched();
        }
    },
    controllerAs: '$ctrl',
    bindings: {
        _states: '<states',
        expanded: '<',
    },
};
